import { notFound, redirect } from 'next/navigation'
import images from '~/asset/images'
import { SignJWT, jwtVerify } from 'jose'
import envConfig from '~/config'

type FormatTime = 'datetime-local' | 'date'

export const formatDateTime = (type: FormatTime, time: string | number | undefined) => {
    if (!time) return ''
    const date = new Date(time)
    // to format datetime-local
    if (type === 'datetime-local') {
        return date.toISOString().slice(0, 16)
    }
    // to format 2021-09-01
    return date.toLocaleDateString('vi', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    })
}

export const convertSlug = (text: string) => {
    const withoutSpecialChars = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    const slug = withoutSpecialChars.toLowerCase().replace(/\s+/g, '-')
    return slug
}

export const handlerErrorServer = (status: number) => {
    switch (status) {
        case 401:
            return redirect('/')
        case 404:
            return notFound()
        case 500:
            return redirect('/500')
    }
}

export const formatTime = (time: Date | string | number): string => {
    const date = new Date(time)
    return date.toLocaleDateString('vi', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    })
}

export const auth = () => {
    const secret = new TextEncoder().encode(process.env.KEY)
    return {
        sign: (payload: { email: string; id: string }) => {
            const signJWT = new SignJWT(payload)
            signJWT.setAudience(envConfig.NEXT_PUBLIC_BASE_URL)
            signJWT.setExpirationTime('7h')
            signJWT.setProtectedHeader({ alg: 'HS256' })
            return signJWT.sign(secret)
        },
        verify: (token: string) =>
            jwtVerify(token, secret).then(
                (res) =>
                    res.payload as {
                        email: string
                        id: string
                        full_name: string
                        roles: string
                        avatar: string
                        user_name: string
                        exp: number
                    }
            )
    }
}

export const normalPath = (path: string) => {
    return path.startsWith('/') ? path : `/${path}`
}

export const urlThumbnail = (url: string | null | undefined) => {
    if (!url) return images.thumbnailDefault.src
    if (url.startsWith('/_next/static')) return url
    if (url.startsWith('http')) return url
    return url.startsWith(envConfig.NEXT_PUBLIC_CLOUDINARY_DOMAIN)
        ? url
        : `${envConfig.NEXT_PUBLIC_CLOUDINARY_URL}${url}`
}

export const isModeDev = () => {
    if (envConfig.NODE_ENV === 'development') {
        return true
    }
    return false
}
